module.exports = __webpack_public_path__ + "static/media/airMeasuring.3a564871.png";